import { render } from "./SiteInfo.vue?vue&type=template&id=6972ed6b&scoped=true"
import script from "./SiteInfo.vue?vue&type=script&lang=js"
export * from "./SiteInfo.vue?vue&type=script&lang=js"

import "./SiteInfo.vue?vue&type=style&index=0&id=6972ed6b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6972ed6b"]])

export default __exports__